import { gql } from "@apollo/client";

export const ORGANIZATION_FIELDS_FRAGMENT = gql`
  fragment OrganizationFields on OrganizationRepresentation {
    id
    name
    picture
    address {
      number
      route
      complement
      stage
      zipPostal
      city
      country
    }
    status
  }
`;

export const ESTABLISHMENT_FIELDS_FRAGMENT = gql`
  fragment EstablishmentFields on EstablishmentRepresentation {
    id
    parentOrganism
    status
    activities
    legalRepresentativeId
    financialInformationId
    userRole
    isOwner
    company {
      legalName
      legalForm
      ice
      commercialRegister {
        number
        courtCity
        modelJ
      }
      taxIdentifier
      professionalTax
      registeredOffice {
        number
        route
        complement
        stage
        zipPostal
        city
        country
      }
    }
    tourismAgreements {
      licenseNumber
      issueDate
      professionalLiabilityInsurance {
        company
        policyNumber
        expiryDate
      }
    }
  }
`;

export const TRIP_FIELDS_FRAGMENT = gql`
fragment TripFields on TripRepresentation {
  id
  establishmentId
  title
  smallDescription
  detailedDescription
  tripProgramDetails {
    id
    picture {
      link
      isMain
    }
    city
    country
    latitude
    longitude
    stay
    description
    activities {
      id
      title
      picture
      description
      isIncluded
      adultPricePerPerson {
        value
        currency
      }
      childPricePerPerson {
        value
        currency
      }
      babiesPricePerPerson {
        value
        currency
      }
    }
    ranking {
      rank
      title
    }
    options {
      id
      picture
      title
      description
      adultPricePerPerson {
        value
        currency
      }
      childPricePerPerson {
        value
        currency
      }
      babiesPricePerPerson {
        value
        currency
      }
    }
  }
}
`;
